import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FieldTextComponent, FieldTextAreaComponent, AbstractFormComponent, FieldNumberComponent, FieldDateComponent } from '@spike/scaffolds';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, FieldTextAreaComponent, FormsModule, ReactiveFormsModule, FieldTextComponent, FieldNumberComponent, FieldDateComponent],
  selector: 'spike-position-general-form',
  templateUrl: './position-general-form.html'
})
export class PositionGeneralFormComponent extends AbstractFormComponent{
  
}
